import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

const Layout = (props) => {
  const { children } = props;
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);
  return (
    <div className="container">
      <Header />
      <div className="body-content">{children}</div>
      {(() => {
        const restrictPaths = ['/sign-in', '/home', '/forgot-password', '/sign-up', '/reset_pwd', '/recent-files-list',
          '/preconfig', '/my-projects', '/shared-projects', '/maintaince'];
        if (restrictPaths.includes(currentPath)) {
          return null;
        }
        return <Footer />;
      })()}
    </div>
  );
};

export default Layout;
